export enum NavigationLocation {
    Global,
    SiteSpecific,
    Side
}

export enum PageLayout {
    Layout12,
    Layout363,
    Layout39,
    Layout93,
    Layout66
}

export enum SearchType {
    Global,
    SiteSpecific,
}

export enum SliderType {
    Basic,
    Cards,
    Gallery
}

export enum NavTypes {
    TOPMENU,
    SITESPECIFIC,
    DETAIL
}